import React, { forwardRef } from 'react';
import {
  Autocomplete as MuiAutocomplete,
  AutocompleteRenderInputParams,
} from '@mui/material';
import { TextField } from '../../atoms/TextField';
import { AutocompleteProps, AutocompleteOption } from './Autocomplete.props';

const AutocompleteComponent = forwardRef<HTMLDivElement, AutocompleteProps>(
  (
    {
      renderInput,
      label,
      placeholder,
      error,
      helperText,
      required,
      sx,
      ...props
    },
    ref
  ) => {
    const defaultRenderInput = (params: AutocompleteRenderInputParams) => (
      <TextField
        {...params}
        label={label}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        required={required}
      />
    );

    return (
      <MuiAutocomplete
        ref={ref}
        renderInput={renderInput || defaultRenderInput}
        sx={{
          ...sx,
        }}
        {...props}
      />
    );
  }
);

AutocompleteComponent.displayName = 'Autocomplete';

export const Autocomplete = AutocompleteComponent as <
  T = AutocompleteOption,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>(
  props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> & {
    ref?: React.Ref<HTMLDivElement>;
  }
) => React.ReactElement;

export default Autocomplete;
